export const BADGE_PERMISSIONS = {
  can_view_badge: {
    codename: "can_view_badge",
    name: "Can view badge"
  },
  can_view_applied_badges: {
    codename: "can_view_applied_badges",
    name: "Can view applied badges"
  }
};
